<template>
  <div class="body edit-theme">
    <div class="tb-form-group">
      <label class="tb-label">Theme title</label>

      <input
        class="tb-input"
        type="text"
        :value="title"
        data-entity="producer-editor-themeTitle"
        @keyup.right.stop
        @keyup.left.stop
        @input="setTitle"
      />
    </div>

    <!-- Only show controls once theme settings are loaded -->
    <div
      v-if="isLoading"
      class="loading loading--inline"
    >
      <i class="icon icon-spinner"></i>
    </div>

    <component
      v-else
      :is="item.layout"
      :item="item"
      :theme="theme"
    />

    <portal to="editor-footer">
      <button
        :disabled="!isCurrentSampleLayout"
        class="tb-btn tb-btn-contained sm sample"
        data-entity="producer-editor-updatePreview"
        @click="sendSampleUpdate"
      >
        Update Preview
      </button>

      <button
        :disabled="!isCurrentLayout"
        class="tb-btn tb-btn-contained sm alarm"
        data-entity="producer-editor-updateLive"
        @click="sendUpdate"
      >
        Update Live
      </button>
    </portal>
  </div>
</template>

<script>
import { isEqual } from 'lodash-es';
import { Portal } from 'portal-vue';

// TODO: Move all these out of nested folders. There's no need for that much abstraction.
import IsolatedComponent from './themes/isolated/Isolated.vue';
import CinematicComponent from './themes/cinematic/Cinematic.vue';
import CarouselComponent from './themes/carousel/Carousel.vue';
import GridComponent from './themes/grid/Grid.vue';
import LowerThirdComponent from './themes/lowerthird/LowerThird.vue';
import LowerThirdScrollComponent from './themes/lowerthirdscroll/LowerThirdScroll.vue';
import MuralComponent from './themes/mural/Mural.vue';
import StoriesComponent from './themes/stories/Stories.vue';
import TickerComponent from './themes/ticker/Ticker.vue';
import WaterfallComponent from './themes/waterfall/Waterfall.vue';

export default {
  components: {
    Portal,
    isolated: IsolatedComponent,
    cinematic: CinematicComponent,
    carousel: CarouselComponent,
    grid: GridComponent,
    lowerthird: LowerThirdComponent,
    lowerthirdscroll: LowerThirdScrollComponent,
    mural: MuralComponent,
    stories: StoriesComponent,
    ticker: TickerComponent,
    waterfall: WaterfallComponent,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  watch: {
    item: {
      deep: true,
      handler(newVal, oldVal) {
        if (!this.isCurrentLayout && !isEqual(newVal, oldVal)) {
          this.sendUpdate();
        }
      },
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.themes.isLoadingMap[this.theme._id];
    },

    theme() {
      return this.$store.state.themes.lookupTable[this.item._id];
    },

    title() {
      return this.item?.title || this.theme?.title || '';
    },

    currentLayoutIndex() {
      return this.$store.state.production.production.index;
    },

    isCurrentLayout() {
      return this.item && (this.item.timeline_id === this.currentLayoutIndex);
    },

    currentSampleLayoutIndex() {
      return this.$store.state.preview.production.index;
    },

    isCurrentSampleLayout() {
      return this.item && (this.item.timeline_id === this.currentSampleLayoutIndex);
    },
  },

  methods: {
    sendUpdate() {
      this.$store.dispatch('updateTimeline');
    },

    sendSampleUpdate() {
      this.$store.dispatch('updatePreviewTimeline');
    },

    setTitle($event) {
      this.$set(this.item, 'title', $event.target.value);
    },
  },
};
</script>
